"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = require("./colors/colors");
const index_1 = require("./font-faces/index");
exports.default = {
    fonts: {
        black: index_1.black,
        bold: index_1.bold,
        book: index_1.book,
        light: index_1.light,
        regular: index_1.regular,
        semibold: index_1.semibold,
    },
    palette: colors_1.default,
};
//# sourceMappingURL=toyota-system.js.map